import angular from 'angular';
import constants from 'app/constants';
import {
  riskDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './deny-change-confirm-dialog.controller';
import template from './deny-change-confirm-dialog.html';


class dialogService {
  getOptions($event, {
    changeType,
    changeEffects,
    change,
    changedIds,
    changesAreRecommended,
    newChanges,
    updateCallback
  }) {
    return {
      controller,
      controllerAs: 'denyChangeConfirmDialogVM',
      locals: {
        changeType,
        changeEffects,
        change,
        changedIds,
        changesAreRecommended,
        newChanges,
        updateCallback
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.pm.denyChangeConfirmDialog', [
  alerts,
  riskDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('denyChangeConfirmDialog', dialogService)
  .name;
